<template>
    <v-card>
      <v-card-text>
        <v-layout>
          <v-flex shrink>
            <piechart :chart-data="chartdata" :options="chartoptions" style="height: 150px; width: 150px;"></piechart>
            <!-- <doughnutchart :chart-data="chartdata" :options="chartoptions" style="height: 150px; width: 150px;"></doughnutchart> -->
          </v-flex>
          <v-flex class="ml-0">
            <v-list dense>
              <template v-for="(item, index) in chart_legend">
                <v-list-tile :key="item.description" class="legend_tile grey--text">
                  <v-list-tile-content>
                    <v-layout align-center>
                      <v-flex shrink>
                        <!-- <div v-bind:style="{ height: '10px', width: '10px', border: '1px solid grey', margin-right: '5px', background: item.color }"></div> -->
                        <div v-bind:style="{ height: '10px', width: '10px', border: '1px solid grey', marginRight: '5px', background: item.color }"></div>
                      </v-flex>
                      <v-flex>
                        {{ item.description }}
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-flex>
        </v-layout>
        <div class="mt-3 ml-2 grey--text">
          <p class="title">Channel status</p>
          <p class="body-1 mb-0"><span class="green--text">{{ numberofchannels }}</span> channel{{ numberofchannels == 1 ? '' : 's' }} total</p>
        </div>
      </v-card-text>
    </v-card>
</template>

<script>
import PieChart from './piechart'
// import DoughnutChart from './doughnutchart'

export default {
  name: 'dash_chanstatus',
  props: {
    chanstates: {
      type: Object,
      required: true
    },
    numberofchannels: {
      type: Number,
      required: true
    }
  },
  components: {
    piechart: PieChart
    // doughnutchart: DoughnutChart
  },
  data: () => ({
    chartdata: null,
    chartoptions: {
      legend: {
        display: false,
        position: 'right'
      },
      maintainAspectRatio: false,
      responsive: true
    },
    chart_legend: [
      {
        description: 'Up',
        color: '#B39DDB'  // deep purple lighten-3
      },
      {
        description: 'Ringing',
        color: '#AEEA00'  // lime accent-4
      },
      {
        description: 'Remote Ring',
        color: '#FF9100'  // orange accent-3
      },
      {
        description: 'Other',
        color: '#00E5FF'   // cyean accent-3
      }
    ]
  }),
  methods: {
    setData: function () {

      if (Object.keys(this.chanstates).length == 0) {
        let no_chan_labels = [
          'No active channels'
        ]
        let no_chan_data = [ 1 ]
        this.chartdata = {
          labels: no_chan_labels,
          datasets: [
            {
              labels: 'States',
              data: no_chan_data,
              backgroundColor: [
                '#aaaaaa'
              ]
            }
          ]
        }
        return
      }

      let new_labels = [
        'Up',
        'Ringing',
        'Remote Ring',
        'Other'
      ]
      let new_data = [ 0,0,0,0 ]
      Object.keys(this.chanstates).forEach((k) => {
        // new_labels.push(k)
        let idx = 3
        if (k === 'Up') {
          idx = 0
        } else if (k === 'Ring') {
          idx = 1
        } else if (k === 'Ringing') {
          idx = 2
        }
        //new_data.push(this.chanstates[k])
        new_data[idx] = this.chanstates[k]
      },this)
      this.chartdata = {
        labels: new_labels,
        datasets: [
          {
            label: 'States',
            data: new_data,
            backgroundColor: [
              this.chart_legend[0].color,
              this.chart_legend[1].color,
              this.chart_legend[2].color,
              this.chart_legend[3].color
            ]
            // borderWidth: [ 10, 10, 10, 10 ]
          }
        ]
      }
    }
  },
  computed: {
    dataAvailable: function () {
      if (!this.chartdata || !this.chartdata.datasets || !this.chartdata.datasets.length) {
        return false
      }
      return this.chartdata.datasets[0].data.length > 0
    }
  },
  watch: {
    chanstates: function () {
      this.setData()
    }
  },
  beforeMount: function () {
    this.setData()
  }
}
</script>

<style scoped>
.legend_tile {
  height: 35px;
}
</style>
